/**
 * CORE-M-05 Ad Group Review tab body — shell.
 *
 * Chans's 2026-09-15 rebuild spec §2.5 asks for the same shape as
 * Campaign Review (M-04) but at ad-group level: Pause / Ignore / Snooze
 * per underperforming ad group.
 *
 * Status (2026-09-24): Art confirmed on 2026-09-22 that M-05 was never
 * blocked on Q-6; the checks are simply not built yet. The shell says so
 * plainly (no sign-off wording, no spec or ticket references on screen) and
 * locks the absence of action buttons until the row list lands.
 */
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useTenantStore } from '@/stores/useTenantStore';

interface AdGroupReviewTabProps {
  tenantId?: string | null;
}

export function AdGroupReviewTab({ tenantId: tenantIdProp }: AdGroupReviewTabProps) {
  const storeTenant = useTenantStore((s) => s.currentTenant);
  const tenantId = (tenantIdProp === undefined ? storeTenant : tenantIdProp) ?? null;

  if (!tenantId) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>No workspace selected</CardTitle>
          <CardDescription>
            Pick a workspace to see its ad-group-level review flags.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          {/* Dev walk 2026-09-24: see CampaignReviewTab. Distinct title, and
              no "nothing flagged": the checks are not built yet. This tab
              was never blocked on Q-6 (Art, 2026-09-22). */}
          <CardTitle>Ad group checks are not built yet</CardTitle>
          <CardDescription>
            Core does not check ad groups on this tab yet, so an empty list
            here does not mean every ad group on {tenantId} is healthy. Until
            the checks are built, open a campaign in Campaign structure below
            to pause or enable its ad groups.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}

export default AdGroupReviewTab;
